import React from 'react'
import ValidatedTextInput from './ValidatedTextInput'

/*
Props:
- name: field name (default: password)
- required: boolean (false)
- pattern: regex to be matched for validation (default: /.{8,}/ = at least 8 chars)
- errorMessage: Self-explanatory. Default: "Invalid password"
- validatedOnChange: callback function for onChange, but including a
  validation flag and field name:
  callback(value, Bool(isValid), this.props.name)

Other props will be forwarded to the TextField element.
*/
const ValidatedPasswordInput = (props) => (
  <ValidatedTextInput
    type="password"
    name={props.name || "password"}
    hintText={props.hintText || "password"}
    floatingLabelText={props.floatingLabelText || "Password"}
    errorMessage={props.errorMessage || "Invalid password"}
    pattern={props.pattern || /.{8,}/}
    {...props}
  />
)

export default ValidatedPasswordInput



// WEBPACK FOOTER //
// ./src/components/UI/ValidatedPasswordInput.jsx